import {ChecklistUserStatus} from '../../services/ChecklistUserStatus';

export const RECEIVE_CHECKLIST_USER_STATUS = 'CHECKLIST/RECEIVE_CHECKLIST_USER_STATUS';

export const receiveChecklistUserStatus = (userStatus: ChecklistUserStatus) => ({
  type: RECEIVE_CHECKLIST_USER_STATUS,
  payload: userStatus,
});
